export default "__VITE_ASSET__B_vx66PE__"